export const OTHER_FC_EKG = ['FC_TENSIOMETER', 'FC_PULSIOX'];
